import React from 'react';
import { Box, Toolbar } from "@mui/material";
import Navbar from "../../components/Navbar/Navbar";
import { Outlet, useRouteLoaderData } from "react-router-dom";
import { NavbarItems } from "../../components/Navbar/navbarItems";
import { User } from "../../models/User";
import UserBar from "../../components/UserBar/UserBar";

interface Props {
  navbarItems: NavbarItems[],
  navbarWidth: number,
}

function NoOrganizationWrapper(props: Props) {
  const user = useRouteLoaderData("user") as User
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{display: 'flex'}}>
      <UserBar onMenuClick={handleDrawerToggle} navBarWidth={props.navbarWidth}/>
      <Box
        component="nav"
        sx={{width: {sm: props.navbarWidth}, flexShrink: {sm: 0}}}
      >
        <Navbar navbarItems={props.navbarItems}
                organizations={user.organizations}
                mobileOpen={mobileOpen}
                onMobileClose={handleDrawerToggle}
                backButton={false}
        />
      </Box>
      <Box
        component="main"
        sx={{flexGrow: 1, px: {xs: 3, sm: 6, xl: 12}, py: 3, width: {sm: `calc(100% - ${props.navbarWidth}px)`}}}
      >
        {/*This Toolbar is needed to push down the content the same as the user bar*/}
        <Toolbar/>
        <Outlet/>
      </Box>
    </Box>
  );
}

export default NoOrganizationWrapper;
